// components/MyPage/components/ProfileSettings.js
import React from "react";
import styled from "styled-components";
import { Upload, Save } from "lucide-react";
import { 
  ContentHeader, 
  ContentTitle, 
  Form, 
  FormGroup, 
  Label, 
  Input, 
  Textarea, 
  SaveButton 
} from "./css";;

const AvatarPreview = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 12px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const UploadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f3f4f6;
  color: #4b5563;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background-color: #e5e7eb;
  }
`;

const AvatarUploadInput = styled.input`
  display: none;
`;

const ProfileSettings = ({ 
  formData, 
  handleChange,
  handleSubmit,
  fileInputRef,
  avatarPreview,
  handleAvatarClick,
  handleFileChange
}) => {
  return (
    <>
      <ContentHeader>
        <ContentTitle>프로필 설정</ContentTitle>
      </ContentHeader>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>프로필 이미지</Label>
          <AvatarPreview>
            <img 
              src={avatarPreview || formData.avatar_url || "/resource/defaultImg.png?height=100&width=100"} 
              alt="프로필 이미지" 
            />
          </AvatarPreview>
          <UploadButton type="button" onClick={handleAvatarClick}>
            <Upload size={16} />
            이미지 업로드
          </UploadButton>
          <AvatarUploadInput
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="username">사용자 이름</Label>
          <Input type="text" id="username" name="username" value={formData.username} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="email">이메일</Label>
          <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="bio">자기소개</Label>
          <Textarea id="bio" name="bio" value={formData.bio} onChange={handleChange} />
        </FormGroup>
        <SaveButton type="submit">
          <Save size={16} />
          저장
        </SaveButton>
      </Form>
    </>
  );
};

export default ProfileSettings;